<template>
  <VenueTable />
</template>

<script>
import VenueTable from '@/components/venue/VenueTable.vue'

export default {
  name: 'VenueView',
  components: {VenueTable},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>
